import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
// import swal from 'sweetalert';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [
    // '../../../assets/css/pages/dashboard4.css',
    // '../../../assets/plugins/chartist-js/dist/chartist.min.css',
    // '../../../assets/plugins/chartist-plugin-tooltip-master/dist/chartist-plugin-tooltip.css'
  ]
})
export class DashboardComponent implements AfterViewInit {
  sMontoTotal = '';
  sMMontoPendienteVendedor = '';
  sMontoPendienteCoordinador = '';
  sMontoPendienteAdmVentas = '';
  sCantProspectosNuevos = '';
  sCantAfiliadosNuevos = '';
  sObjetivoMonto = '';
  sObjetivoNuevosAfiliados = '';

  selectedMonth = 0;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngAfterViewInit() {
  }

  onChange_cbo(monthId: number): void {
    // const valor = +$event.target.options[$event.target.options.selectedIndex].value;
    this.selectedMonth = monthId;
  }

}
